<script lang="ts">
  import LoaderAnimation from "./LoaderAnimation.svelte"
</script>

<div class="cartModalWaitMessage">
  <div class="line1">
    Loading Your Recommendation
  </div>
  <div class="loader">
    <LoaderAnimation />
  </div>
  <div class="line2">
    Please Wait
  </div>
</div>

<style lang="scss">
  .cartModalWaitMessage {
    text-align: center;
    color: #252525;
    margin: 14px 40px 30px;
    font-family: canada-type-gibson;

    .line1 {
      font-size: 24px;
      line-height: 32px;
    }
    .line2 {
      font-size: 18px;
      line-height: 24px;
    }

    .loader {
      margin: 50px 0;
    }
  }
</style>
